module.exports = __webpack_public_path__ + "img/crown.4e0bc5b9.png";